import React, { Component } from 'react'
import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Paper,
    TextField,
} from '@mui/material'
import SelectList from '../../../Elements/SelectList'
import { CirclePicker } from 'react-color'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'

class BlockFormPercentageChartSetting extends Component {
    constructor(props) {
        super(props)

        this.state = {
            pie_charts:
                this.props.pie_charts && Array.isArray(this.props.pie_charts)
                    ? this.props.pie_charts
                    : [],
        }
        this.removeTotal = this.removeTotal.bind(this)
        this.removeQuery = this.removeQuery.bind(this)
        this.onDeleteChart = this.onDeleteChart.bind(this)
    }

    removeTotal(index) {
        let pieCharts = this.state.pie_charts
        pieCharts[index].total_query = null
        this.setState({ pie_charts: pieCharts })
        this.props.onChange(pieCharts)
    }

    removeQuery(index) {
        let pieCharts = this.state.pie_charts
        pieCharts[index].dossier_query = null
        this.setState({ pie_charts: pieCharts })
        this.props.onChange(pieCharts)
    }

    onDeleteChart(index) {
        let pieCharts = this.state.pie_charts
        pieCharts.splice(index, 1)
        this.setState({ pie_charts: pieCharts })
        this.props.onChange(pieCharts)
    }

    render() {
        const kedo = this.props.kedo
        const { pie_charts } = this.state

        return (
            <div>
                <h3>{kedo.t('Percentage settings')}</h3>

                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => {
                        let pieCharts = [...pie_charts, {}]
                        this.setState({ pie_charts: pieCharts })
                        this.props.onChange(pieCharts)
                    }}
                    sx={{ mb: 2 }}
                >
                    {kedo.t('Add')}
                </StyledButton>

                <TableContainer component={Paper}>
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell>
                                    {kedo.t('Total')} {kedo.t('Query')}
                                </TableCell>
                                <TableCell>
                                    {kedo.t('Percentage')} {kedo.t('Query')}
                                </TableCell>
                                <TableCell>{kedo.t('Color')}</TableCell>
                                <TableCell>{kedo.t('Title')}</TableCell>
                                <TableCell>{/* Actions if needed */}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {pie_charts.map((pieItem, index) => (
                                <TableRow
                                    key={index}
                                    sx={{
                                        '&:nth-of-type(odd)': {
                                            backgroundColor: 'action.hover',
                                        },
                                    }}
                                >
                                    <TableCell>
                                        <SelectList
                                            currentValue={
                                                pie_charts[index]
                                                    ? pie_charts[index]
                                                          .total_query
                                                    : null
                                            }
                                            onClear={() =>
                                                this.removeTotal(index)
                                            }
                                            searchName={'search'}
                                            kedo={this.props.kedo}
                                            urlParams={{
                                                page: 0,
                                                limit: 200,
                                                environment: kedo
                                                    .env()
                                                    .getEnvironment().id,
                                                defDossier:
                                                    this.props.defDossier,
                                            }}
                                            onDisplayName={(item) =>
                                                kedo
                                                    .env()
                                                    .translateItem(
                                                        item,
                                                        'dossierquery'
                                                    )
                                            }
                                            url={kedo
                                                .api()
                                                .getDossierQueryEndpoint()}
                                            onSelect={(item) => {
                                                let pieCharts = [
                                                    ...this.state.pie_charts,
                                                ]
                                                pieCharts[index].total_query =
                                                    item.id
                                                this.setState({ pie_charts })
                                                this.props.onChange(pieCharts)
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <SelectList
                                            currentValue={
                                                pie_charts[index]
                                                    ? pie_charts[index]
                                                          .dossier_query
                                                    : null
                                            }
                                            onClear={() =>
                                                this.removeQuery(index)
                                            }
                                            searchName={'search'}
                                            kedo={this.props.kedo}
                                            urlParams={{
                                                page: 0,
                                                limit: 200,
                                                environment: kedo
                                                    .env()
                                                    .getEnvironment().id,
                                                defDossier:
                                                    this.props.defDossier,
                                            }}
                                            onDisplayName={(item) =>
                                                kedo
                                                    .env()
                                                    .translateItem(
                                                        item,
                                                        'dossierquery'
                                                    )
                                            }
                                            url={kedo
                                                .api()
                                                .getDossierQueryEndpoint()}
                                            onSelect={(item) => {
                                                let pieCharts = [
                                                    ...this.state.pie_charts,
                                                ]
                                                pieCharts[index].dossier_query =
                                                    item.id
                                                this.setState({ pie_charts })
                                                this.props.onChange(pieCharts)
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <CirclePicker
                                            color={
                                                pie_charts[index]
                                                    ? pie_charts[index].color
                                                    : null
                                            }
                                            onChangeComplete={(color) => {
                                                let pieCharts = [
                                                    ...this.state.pie_charts,
                                                ]
                                                pieCharts[index].color =
                                                    color.hex
                                                this.setState({ pie_charts })
                                                this.props.onChange(pieCharts)
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <TextField
                                            size="small"
                                            variant="outlined"
                                            fullWidth
                                            value={
                                                pie_charts[index]
                                                    ? pie_charts[index].title ||
                                                      ''
                                                    : ''
                                            }
                                            onChange={(e) => {
                                                let pieCharts = [
                                                    ...this.state.pie_charts,
                                                ]
                                                pieCharts[index].title =
                                                    e.target.value
                                                this.setState({ pie_charts })
                                                this.props.onChange(pieCharts)
                                            }}
                                        />
                                    </TableCell>

                                    <TableCell>
                                        <StyledButton
                                            color="error"
                                            variant="outlined"
                                            invert
                                            onClick={() =>
                                                this.onDeleteChart(index)
                                            }
                                        >
                                            Delete
                                        </StyledButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        )
    }
}

export default BlockFormPercentageChartSetting
